<template>
    <div class="app-header">
    </div>
</template>

<script>
import Vue from 'vue';
import { mapState, mapGetters, mapActions } from "vuex";

export default {  
    name: 'Base',
    created(){
        this.initializeData({});
    },
    watch: {
        loggedInUserInformation(){
            let self = this;
            if(self.loggedInUserInformation){
                let publicUser = self.loggedInUserInformation['tenant_information']['schema_name'] == 'public' && self.loggedInUserInformation['is_superuser'] ? true : false;
                if(self.loggedInUserInformation['is_superadmin'] || publicUser){
                    self.$router.push('/tenants');
                }
                 else {
                    let appsInformation = self.loggedInUserInformation['apps_information'];
                    let docsInformation = self.loggedInUserInformation['docs_information'];
                    let tenantAdmin = self.loggedInUserInformation['is_tenantadmin'];
                    if(Object.keys(appsInformation).length == 0 && Object.keys(docsInformation).length == 0 && !tenantAdmin){
                        self.$router.push('/noapp_nodoc');
                    } else if(Object.keys(appsInformation).length == 0 && Object.keys(docsInformation).length){
                        self.$router.push('/docs/all');
                    }else {
                        self.getUserPageInfo();
                    }
                }
            }
        }
    },
    computed: {
        ...mapState({
            loggedInUserInformation: state => state.loginDetails.loggedInUserInformation,
        }),
    },
    methods:{
        ...mapActions({
            initializeData: 'loginDetails/initializeData',
            getUserPageInfo: 'loginDetails/userPageInfo'
        }),
    }
}
</script>
